import { Layout } from "../../layout";
import { UserOrgPreferencesForm } from "../components";
import { McpKeyList } from "../../mcp-keys/components/McpKeyList";
import { H2, IconButton } from "@datapay-by-datacom/design-system";
import { IoChevronBack } from "react-icons/io5";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";
import { FeatureFlag, useFeatureFlagValue } from "../../feature-flags";
import s from "./SettingsScreen.module.css";

export function SettingsScreen() {
  const navigate = useNavigate();
  const mcpKeysEnabled = useFeatureFlagValue(FeatureFlag.EnableMcpKeysInterface);

  return (
    <Layout>
      <div className={s.container}>
        <div className={s.header}>
          <div className={s.headerContent}>
            <IconButton onPress={() => navigate(-1)} aria-label="Go back">
              <IoChevronBack size={20} />
            </IconButton>
            <H2>Settings</H2>
          </div>
        </div>

        <div className={s.content}>
          <Link to="/release-announcements" className={s.link}>
            Release Announcements
          </Link>
          <UserOrgPreferencesForm />
          {mcpKeysEnabled && <McpKeyList />}
        </div>
      </div>
    </Layout>
  );
}
